import type {IProject} from '../../models/interfaces/project.interface';
import type {IItemsSelect} from '../../models/interfaces/selectItems.interface';
import {parseUtcTimestamp} from '../../utils/date';

export const DATE_FILTER = ['today', 'last_5_days', 'last_2_weeks', 'last_month'] as const;

export const isProjectInDateFilter = (
  project: IProject,
  dateFilter: IItemsSelect,
  now: Date = new Date(),
): boolean => {
  const createdAt = new Date(parseUtcTimestamp(project.createdAt));

  switch (dateFilter.id) {
    case DATE_FILTER[0]:
      return createdAt.toDateString() === now.toDateString();
    case DATE_FILTER[1]:
      return createdAt >= new Date(now.getFullYear(), now.getMonth(), now.getDate() - 5);
    case DATE_FILTER[2]:
      return createdAt >= new Date(now.getFullYear(), now.getMonth(), now.getDate() - 14);
    case DATE_FILTER[3]:
      return createdAt >= new Date(now.getFullYear(), now.getMonth() - 1, now.getDate());
    case 'older':
      return createdAt < new Date(now.getFullYear(), now.getMonth() - 1, now.getDate());
    default:
      return false;
  }
};
